var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toggle 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2853",
    width: 22.4,
    height: 12.8,
    rx: 6.4,
    transform: "matrix(-1 0 0 1 23.3999 1.59998)",
    fill: "#C5C8D3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Close circle",
    filter: "url(#filter0_d_458_34765)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4001 12.8C10.0511 12.8 12.2001 10.6509 12.2001 7.99995C12.2001 5.34898 10.0511 3.19995 7.4001 3.19995C4.74913 3.19995 2.6001 5.34898 2.6001 7.99995C2.6001 10.6509 4.74913 12.8 7.4001 12.8ZM9.66635 10.2662C9.84441 10.0882 9.84441 9.79679 9.66635 9.61873L8.04763 7.99998L9.66612 6.38147C9.84418 6.20341 9.84418 5.91205 9.66612 5.73399C9.48807 5.55593 9.1967 5.55593 9.01865 5.73399L7.40016 7.3525L5.78151 5.73383C5.60345 5.55577 5.31209 5.55577 5.13404 5.73383C4.95598 5.91189 4.95598 6.20325 5.13404 6.38131L6.75268 7.99998L5.13381 9.61889C4.95575 9.79695 4.95575 10.0883 5.13381 10.2664C5.31186 10.4444 5.60322 10.4444 5.78128 10.2664L7.40016 8.64747L9.01888 10.2662C9.19693 10.4443 9.4883 10.4443 9.66635 10.2662Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_458_34765",
    x: 0.600098,
    y: 3.19995,
    width: 13.6001,
    height: 13.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_458_34765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_458_34765",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggle-off.26fc011b8395b07f44f0f4a56944da13.svg";
export { ForwardRef as ReactComponent };